import { render, staticRenderFns } from "./GiftTransferImportForm.vue?vue&type=template&id=ab896902&"
import script from "./GiftTransferImportForm.vue?vue&type=script&lang=js&"
export * from "./GiftTransferImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports